<template>
  <div>
    <div v-show="login_show" :class="['login-wrapper', ['', 'login-form-right', 'login-form-left'][direction]]">
      <el-form ref="form" size="large" :model="form" :rules="rules" class="login-form ele-bg-white"
        @keyup.enter.native="doSubmit">
        <div class="login-header">
          <div class="login-icon">
            <i class="el-icon-user"></i>
          </div>
          <h4>{{ $t('login.title') }}</h4>
          <p>{{ $t('login.tip') }}</p>
        </div>

        <el-form-item prop="username">
          <el-input clearable v-model="form.username" prefix-icon="el-icon-user" :placeholder="$t('login.username')" />
        </el-form-item>

        <el-form-item prop="password">
          <el-input show-password v-model="form.password" prefix-icon="el-icon-lock"
            :placeholder="$t('login.password')" />
        </el-form-item>

        <el-form-item prop="google_token" v-show="show">
          <el-input v-model="form.google_token" prefix-icon="el-icon-_vercode" placeholder="请输入谷歌验证码" />
        </el-form-item>

        <el-form-item prop="captcha">
          <div class="login-input-group">
            <el-input clearable v-model="form.captcha" prefix-icon="el-icon-_vercode"
              :placeholder="$t('login.captcha')" />
            <img alt="" v-if="captcha" :src="captcha" @click="changeCode" class="login-captcha" />
          </div>
        </el-form-item>

        <div class="el-form-item">
          <el-checkbox v-model="form.remember">{{ $t('login.remember') }}</el-checkbox>
        </div>

        <div class="el-form-item">
          <el-button size="large" type="primary" class="login-btn" :loading="loading" @click="doSubmit">
            {{ loading ? $t('login.loading') : $t('login.login') }}
          </el-button>
        </div>

      </el-form>
      <!-- 多语言切换 -->
      <div class="language-switcher">
        <el-dropdown placement="bottom" @command="changeLanguage">
          <i class="el-icon-_language" style="font-size: 22px;color: #fff;cursor: pointer;"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="en">
              <span :class="{ 'ele-text-primary': language === 'en' }">English</span>
            </el-dropdown-item>
            <el-dropdown-item command="zh_CN">
              <span :class="{ 'ele-text-primary': language === 'zh_CN' }">简体中文</span>
            </el-dropdown-item>
            <el-dropdown-item command="zh_TW">
              <span :class="{ 'ele-text-primary': language === 'zh_TW' }">繁體中文</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import setting from '@/config/setting';
import { fetchLoginIpAccess, isLoginIpAllowed, handleLoginAccessDenied } from '@/utils/login-ip';

export default {
  name: 'Login',
  data() {
    return {
      // 登录框方向, 0居中, 1居右, 2居左
      direction: 0,
      // 加载状态
      loading: false,
      // 表单数据
      form: {
        username: '',
        password: '',
        captcha: '',
        key: '',
        remember: false
      },
      // 验证码base64数据
      captcha: '',
      show: false,
      login_show: false,
    };
  },
  computed: {
    // 表单验证规则
    rules() {
      return {
        username: [{
          required: true,
          message: this.$t('login.username'),
          type: 'string',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: this.$t('login.password'),
          type: 'string',
          trigger: 'blur'
        }],
        captcha: [{
          required: true,
          message: this.$t('login.captcha'),
          type: 'string',
          trigger: 'blur'
        }]
      };
    },
    // 当前语言
    language() {
      return this.$i18n.locale;
    }
  },
  mounted() {
    if (setting.takeToken()) {
      this.goHome();
    } else {
      this.verifyLoginAccess();
    }
  },
  methods: {
    verifyLoginAccess() {
      fetchLoginIpAccess()
        .then((res) => {
          if (isLoginIpAllowed(res)) {
            this.login_show = true;
            this.changeCode();
          } else {
            handleLoginAccessDenied(res);
          }
        })
        .catch((e) => {
          handleLoginAccessDenied(e);
        });
    },
    /* 提交 */
    doSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
        if (this.show && !this.form.google_token) {
          this.$message.error("谷歌验证码不能为空");
          return false;
        }
        this.loading = true;
        this.$http.post('/login/login', this.form).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success('登录成功');
            this.$store.dispatch('user/setToken', {
              token: 'Bearer ' + res.data.data.access_token,
              remember: this.form.remember
            }).then(() => {
              this.goHome();
            });
          } else {
            if (res.data.msg == "1") {
              this.show = true;
            } else {
              this.$message.error(res.data.msg);
              // 重新刷新验证码
              this.changeCode()
            }

          }
        });
      });
    },
    /* 跳转到首页 */
    goHome() {
      const query = this.$route.query;
      const path = query && query.from ? query.from : '/';
      this.$router.push(path).catch(() => { });
    },
    /* 更换图形验证码 */
    changeCode() {
      // 这里演示的验证码是后端返回base64格式的形式, 如果后端地址直接是图片请参考忘记密码页面
      this.$http.get('/login/captcha').then(res => {
        if (res.data.code === 0) {
          this.captcha = res.data.data.captcha;
          this.form.key = res.data.data.key;
          this.$refs.form.clearValidate();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        this.$message.error(e.message);
      });
    },
    /* 切换语言 */
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('i18n-lang', lang);
    }
  }
}
</script>

<style scoped>
.login-wrapper {
  padding: 50px 20px;
  position: relative;
  box-sizing: border-box;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  overflow: hidden;
}

/* 卡片 */
.login-form {
  margin: 0 auto;
  width: 460px;
  max-width: 100%;
  padding: 50px 60px;
  position: relative;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  border-radius: 16px;
  z-index: 10;
  background: #fff;
}

/* 登录头部 */
.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.login-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.25);
}

.login-icon i {
  font-size: 42px;
  color: white;
}

.login-header h4 {
  margin: 0 0 10px 0;
  font-size: 28px;
  font-weight: 700;
  color: #303133;
  letter-spacing: 1px;
}

.login-header p {
  margin: 0;
  font-size: 14px;
  color: #909399;
  font-weight: 400;
}

.login-form-right .login-form {
  margin: 0 15% 0 auto;
}

.login-form-left .login-form {
  margin: 0 auto 0 15%;
}

.login-form>.el-form-item {
  margin-bottom: 28px;
}

/* 验证码 */
.login-input-group {
  display: flex;
  align-items: center;
}

.login-input-group ::v-deep .el-input {
  flex: 1;
}

.login-captcha {
  height: 40px;
  width: 110px;
  margin-left: 12px;
  border-radius: 8px;
  border: 1px solid #DCDFE6;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.login-captcha:hover {
  opacity: 0.75;
  transform: scale(1.05);
}

.login-btn {
  display: block;
  width: 100%;
  padding: 14px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.25);
}

.login-btn:hover {
  opacity: 0.92;
}

/* 美化输入框 */
::v-deep .el-input__inner {
  border-radius: 10px;
  font-size: 15px;
  padding: 14px 40px 14px 50px;
  transition: all 0.3s ease;
  border: 1px solid #e4e7ed;
}

::v-deep .el-input__inner:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.15);
}

::v-deep .el-input__prefix {
  left: 16px;
  color: #909399;
  font-size: 18px;
  line-height: 40px;
}

::v-deep .el-input--prefix .el-input__inner {
  padding-left: 50px;
}

::v-deep .el-input--suffix .el-input__inner {
  padding-right: 40px;
}

::v-deep .el-input__suffix {
  right: 12px;
}

::v-deep .el-input__suffix .el-input__icon {
  color: #c0c4cc;
  font-size: 18px;
}

::v-deep .el-input__suffix .el-input__icon:hover {
  color: #667eea;
}

::v-deep .el-checkbox__label {
  font-weight: 500;
  font-size: 14px;
  color: #606266;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #667eea;
  border-color: #667eea;
}

::v-deep .el-input__inner::placeholder {
  color: #c0c4cc;
  font-size: 14px;
}

/* 语言切换器 */
.language-switcher {
  position: absolute;
  right: 30px;
  top: 20px;
  z-index: 100;
}

.el-icon-_language {
  color: #ffffff !important;
  font-size: 26px !important;
  transition: transform 0.3s ease;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.el-icon-_language:hover {
  transform: scale(1.1);
}

/* 响应式 */
@media screen and (min-height: 550px) {
  .login-form {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
    margin-top: -220px;
  }

  .login-form-right .login-form,
  .login-form-left .login-form {
    left: auto;
    right: 15%;
    transform: translateX(0);
    margin: -220px auto auto auto;
  }

  .login-form-left .login-form {
    right: auto;
    left: 15%;
  }
}

@media screen and (max-width: 768px) {

  .login-form-right .login-form,
  .login-form-left .login-form {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    margin-right: auto;
  }
}
</style>